<!--
배송지비용 청구서 삭제
------------------------------------
-->
<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-xxlarge">

            <div class="uk-modal-header">
                <h4>
                    <i class="material-icons md-24">add_box</i>
                    <span class="uk-text-middle uk-text-danger">배송지비용 청구서 삭제</span>
                </h4>
            </div>

            <div class="uk-modal-body uk-padding-remove">
                <table class="input-table">

                <tr>
                    <th>
                        <i class="material-icons">
                            account_circle
                        </i>
                        회원사
                    </th>
                    <td>
                        {{ cost.user_nick }}
                    </td>
                    <th>
                        <i class="material-icons">
                            tag
                        </i>
                        상품번호
                    </th>
                    <td>
                        {{ cost.prod_id }}
                    </td>
                </tr>

                <tr>
                    <th>
                        <i class="material-icons">
                            tag
                        </i>
                        배송코드
                    </th>
                    <td>
                        {{ cost.house_code }}
                    </td>
                    <th>
                        <i class="material-icons">
                            account_box
                        </i>
                        수취인
                    </th>
                    <td>
                        {{ cost.house_name }}
                    </td>
                </tr>

                <tr>
                    <th>
                        <i class="material-icons">
                            location_on
                        </i>
                        배송지
                    </th>
                    <td>
                        {{ cost.shipping_center }}
                    </td>

                    <th>
                        <i class="material-icons">
                            local_shipping
                        </i>
                        트래킹번호
                    </th>
                    <td>
                        {{ cost.tracking_no }}
                    </td>
                </tr>

                <tr>
                    <th>
                        <i class="material-icons">
                            attach_money
                        </i>
                        청구비용({{ cost.region_currency }})
                    </th>
                    <td>
                        {{ cost.cost }}
                    </td>
                    <td colspan="2"></td>
                </tr>

                <tr>
                    <th>
                        <i class="material-icons">
                            comment
                        </i>
                        청구내용(메모)
                    </th>
                    <td colspan="3" v-nl2br="cost.memo">
                    </td>
                </tr>
                </table>








            </div>


            <div class="uk-modal-footer uk-text-right">
                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default uk-modal-close"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>
                <button
                    type="button"
                    class="uk-button uk-button-danger"
                    v-on:click="submit()"
                >
                    <span uk-icon="icon: trash"></span>
                    삭제(완료)
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            // csrf-token
            csrfToken: String,
        },
        data: function () {
            return {
                // (object) 배송지비용
                cost: {},

            };
        },
        computed: {
        },
        methods: {
            /**
             * 입력폼 display
             */
            displayForm() {
                UIkit.modal(this.$el).show();
            },

            /**
             * 폼
             * @param cost_id
             */
            form(cost_id) {

                // 초기화
                this.cost = {};

                // 조회
                this.loadPromise(cost_id)
                    .then((response) => {
                        // 결과저장
                        this.cost = response.cost;

                        // 폼띄우기
                        this.displayForm();

                    });
            },

            /**
             * 초기정보 조회
             * @param cost_id
             */
            loadPromise(cost_id) {
                // promise 생성
                return new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/shipping-center-costs/' + cost_id,
                        data: {
                        },
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                        error: (jqXHR, textStatus, errorThrown) => {
                            // promise 실패
                            reject();
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });
            },


            /**
             * submit
             */
            submit() {
                // ajax 옵션
                let opts = {
                    type: 'delete',
                    url: '/shipping-center-costs/'+this.cost.id,
                    data: {
                        '_token': this.csrfToken,
                    },
                    success: (response, textStatus, jqXHR) => {
                        UIkit.modal.alert(response.msg).then(function () {
                            $.app.refresh();
                        });
                    },
                };

                // ajax 실행
                $.app.ajax.module.default(opts);
            },
        },
    }
</script>

<style lang="scss" scoped>
    // 테이블
    .input-table {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;

        th, td {
            text-align: left;
            border: 1px solid #cfcfcf;
            font-weight: normal;

            padding: 1rem;
            color: #000;
        }

        th {

            font-size: 1rem;
            background-color: #fefefe;
            width: 10rem;

            .material-icons {
                vertical-align: middle;
                font-size: 1.25rem;
                color: #aaa;
            }

        }
        td {
            text-align: center;
            font-size: 1rem;
            color: #000;
        }

    }
</style>